function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n    .st0{opacity:0.15;fill:#1EA3CE;}\n    .st1{fill:#7D5544;}\n    .st2{fill:#F1C29A;}\n    .st3{fill:#663521;}\n    .st4{fill:#FFFFFF;}\n    .st5{opacity:0.1;fill:#1B1D21;}\n    .st6{fill:#1BA3CE;}\n    .st7{fill:#F8BBBC;}\n    .st8{fill:#ECA3AD;}\n    .st9{fill:#231F20;}\n    .st10{fill:#5C6169;}\n    .st11{fill:#D4D2CF;}\n    .st12{fill:#F7C8BF;}\n    .st13{fill:#414042;}\n    .st14{fill:#1C4270;}\n    .st15{opacity:5.000000e-02;fill:#1B1D21;}\n    .st16{fill:#1EA3CE;}\n    .st17{fill:#FF9E00;}\n    .st18{fill:none;}\n    .st19{fill:#ECAE8D;}\n    .st20{fill:#7F572A;}\n    .st21{fill:#A17940;}\n    .st22{opacity:0.15;fill:#1BA3CE;}\n    .st23{fill:#D5D2D0;}\n    .st24{fill:#F9BCBD;}\n    .st25{fill:#EDA4AE;}\n    .st26{fill:#675B5B;}\n    .st27{fill:#E6E6E6;}\n    .st28{fill:#501616;}\n    .st29{fill:#333B44;}\n    .st30{opacity:0.99;fill:#E6E6E6;enable-background:new    ;}\n    .st31{fill:#A02C2C;}\n    .st32{fill:#784421;}\n    .st33{fill:#A05A2C;}\n    .st34{fill:#00BA6B;}\n    .st35{fill:#E6A800;}\n    .st36{fill:#88949F;}\n    .st37{opacity:0.45;fill:#00BA6B;}\n    .st38{fill:#7F3DB3;}\n    .st39{fill:#5B3A2F;}\n    .st40{fill:#B58361;}\n    .st41{fill:#FF9F00;}\n    .st42{fill:#1DA3CE;}\n    .st43{fill:#1AA3CE;}\n    .st44{opacity:0.3;fill:#1AA3CE;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_12"
}, React.createElement("path", {
  className: "st0",
  d: "M265.3,182.6c64.5,0,102.9-7.5,134.8-15.3V52.1c-4.2,1-8.3,2.1-12.3,3.1C354.8,63.7,326.4,71,265.3,71         c-61.1,0-89.5-7.3-122.5-15.7C108.8,46.5,70.5,36.7,0,36v111.7c56,0.6,83.5,7.6,115,15.7C150.2,172.4,190,182.6,265.3,182.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M537.9,147.6c61.1,0,89.5,7.3,122.5,15.7c33.5,8.6,71.2,18.3,139.6,19.2V70.9c-53.9-0.8-80.9-7.7-111.9-15.7         c-35.2-9-75-19.3-150.2-19.3c-66.6,0-105.5,8-137.9,16.1v115.2c5.3-1.3,10.4-2.6,15.5-3.9C448.4,154.9,476.8,147.6,537.9,147.6z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_6"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st17",
  d: "M257,138.2H127c-1.4,0-2.5-1.1-2.5-2.5V60.5c0-1.4,1.1-2.5,2.5-2.5h130c1.4,0,2.5,1.1,2.5,2.5v75.1             C259.6,137,258.4,138.2,257,138.2z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_1_",
  d: "M257,138.2H127c-1.4,0-2.5-1.1-2.5-2.5V60.5c0-1.4,1.1-2.5,2.5-2.5h130c1.4,0,2.5,1.1,2.5,2.5v75.1                     C259.6,137,258.4,138.2,257,138.2z"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st4",
  d: "M192,75.9c-12,0-21.6,9.7-21.6,21.6s9.7,21.6,21.6,21.6s21.6-9.7,21.6-21.6S204,75.9,192,75.9z M193.6,109.7                 v1.9c0,0.9-0.7,1.6-1.5,1.6c-0.8,0-1.4-0.7-1.4-1.6v-1.9c-3-0.4-5.4-2.2-6.5-4.1c-0.2-0.3-0.3-0.6-0.3-1c0-1,0.8-1.9,1.7-1.9                 c0.7,0,1.1,0.4,1.4,0.8c1.3,1.5,3,2.6,5.1,2.6c2.8,0,4.2-1,4.2-3.2c0-5.1-11.4-2.7-11.4-11.1c0-3.1,1.8-5.8,5.8-6.3v-2                 c0-0.9,0.7-1.6,1.4-1.6c0.8,0,1.5,0.7,1.5,1.6v2c2.5,0.3,4.6,1.5,5.6,3.1c0.2,0.3,0.3,0.7,0.3,1.1c0,1-0.8,1.8-1.7,1.8                 c-0.4,0-0.9-0.3-1.3-0.8c-1-1-2.6-1.8-4.4-1.8c-2.6,0-3.6,1.4-3.6,2.7c0,4.6,11.4,2.4,11.4,11.1                 C200,106.7,197.8,109.2,193.6,109.7z"
}), React.createElement("g", null, React.createElement("path", {
  className: "st4",
  d: "M177.1,123.4c-9.2-5.3-14.9-15.2-14.9-25.9c0-5,1.3-9.9,3.6-14.2l0.3,1.3c0.1,0.7,0.8,1.2,1.5,1.2                     c0.1,0,0.2,0,0.3,0c0.8-0.2,1.3-1,1.2-1.8l-1-4.9c-0.1-0.4-0.3-0.7-0.6-0.9c-0.3-0.2-0.7-0.3-1.1-0.2l-4.9,1                     c-0.8,0.2-1.3,1-1.2,1.8c0.2,0.8,1,1.3,1.8,1.2l1.4-0.3c-2.7,4.9-4.2,10.4-4.2,16c0,11.7,6.3,22.6,16.4,28.4                     c0.2,0.1,0.5,0.2,0.7,0.2c0.5,0,1-0.3,1.3-0.8C178.1,124.8,177.9,123.8,177.1,123.4z"
}), React.createElement("path", {
  className: "st4",
  d: "M177,71.8c4.5-2.6,9.7-4,15-4c10.4,0,19.9,5.3,25.3,14.1l-1.3-0.4c-0.8-0.2-1.6,0.2-1.9,1                     c-0.2,0.8,0.2,1.6,1,1.9l4.8,1.5c0.1,0,0.3,0.1,0.4,0.1c0.6,0,1.2-0.4,1.4-1.1l1.5-4.8c0.2-0.8-0.2-1.6-1-1.9                     c-0.8-0.2-1.6,0.2-1.9,1l-0.4,1.4c-5.9-9.8-16.5-15.7-28-15.7c-5.8,0-11.5,1.5-16.5,4.4c-0.7,0.4-1,1.3-0.5,2.1                     C175.4,72,176.3,72.2,177,71.8z"
}), React.createElement("path", {
  className: "st4",
  d: "M224.8,97.6l0-0.1c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5l0,0.1c0,16.3-13.1,29.5-29.3,29.8l1-0.9                     c0.6-0.6,0.6-1.5,0.1-2.1c-0.6-0.6-1.5-0.6-2.1-0.1l-3.6,3.5c-0.3,0.3-0.5,0.7-0.5,1c0,0.4,0.1,0.8,0.4,1.1l3.4,3.6                     c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.7-0.1,1-0.4c0.6-0.6,0.6-1.5,0.1-2.1l-1-1C210.3,130.2,224.8,115.5,224.8,97.6z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st18",
  d: "M304,147.3l-0.3,4.7l-0.1,1.2l1.7-2.7c1.7-2.6,4.2-4.1,6.2-3.9c0.2-0.1,0.3-0.2,0.5-0.2c0-0.1,0-0.2,0-0.2                 c0-0.1,0-0.2,0-0.3c-2.2-0.3-4-0.9-5.5-1.7c-0.1,0.3-0.2,0.6-0.4,0.9C305.6,146,304.8,146.7,304,147.3z"
}), React.createElement("polygon", {
  className: "st19",
  points: "303.7,152 303.6,153.2 303.6,153.2             "
}), React.createElement("path", {
  className: "st19",
  d: "M297.6,143.8C297.6,143.8,297.6,143.8,297.6,143.8C297.6,143.8,297.6,143.8,297.6,143.8                 C297.6,143.8,297.6,143.8,297.6,143.8z"
}), React.createElement("path", {
  className: "st19",
  d: "M303.7,152l0.3-4.7c0.8-0.5,1.5-1.3,2-2.3c0.1-0.3,0.3-0.6,0.4-0.9c-3.1-1.6-5-3.9-6.3-5.8                 c-0.7,0.5-1.4,1.2-1.9,2.2c-0.6,1.1-0.8,2.2-0.7,3.3c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.2-0.1,0.5-0.1,0.7l-1,13.2                 c-0.2,3.1,0.6,6.2,2.4,8.7c1.7,2.4,5.3,1.8,6.2-1.1l0.6-2.1l0.2-2.9l-2.7-1.8l0.4-5.4L303.7,152z"
}), React.createElement("path", {
  className: "st2",
  d: "M251.8,162.3l-1,20.2c1.2,0,2.5,0,3.8,0.1l1.1-19.5L251.8,162.3z"
}), React.createElement("path", {
  className: "st2",
  d: "M276.2,138.7c-1.2,1.3-2.7,2.3-4.2,3.1C273.5,141,274.9,139.9,276.2,138.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M280.5,132.3c-0.6,1.4-1.3,2.7-2.2,3.9C279.1,135,279.9,133.7,280.5,132.3z"
}), React.createElement("path", {
  className: "st2",
  d: "M276.9,137.9c-0.2,0.2-0.4,0.5-0.7,0.7C276.5,138.4,276.7,138.2,276.9,137.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M277.6,137.1c-0.2,0.2-0.4,0.5-0.6,0.7C277.2,137.6,277.4,137.4,277.6,137.1z"
}), React.createElement("path", {
  className: "st2",
  d: "M278.3,136.2c-0.2,0.3-0.4,0.5-0.6,0.8C277.9,136.8,278.1,136.5,278.3,136.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M270,142.7c-0.3,0.1-0.6,0.2-0.9,0.3C269.4,143,269.7,142.9,270,142.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M272,141.8c-0.3,0.2-0.6,0.3-0.9,0.4C271.4,142.2,271.7,142,272,141.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M271,142.3c-0.3,0.1-0.6,0.3-0.9,0.4C270.4,142.6,270.7,142.5,271,142.3z"
}), React.createElement("path", {
  className: "st2",
  d: "M269,143.1c-0.3,0.1-0.7,0.2-1,0.3C268.3,143.3,268.6,143.2,269,143.1z"
}), React.createElement("path", {
  className: "st2",
  d: "M284.8,130.9c-0.2,0.2-0.5,0.4-0.8,0.5C284.3,131.3,284.6,131.1,284.8,130.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M286.1,129.5c-0.2,0.2-0.3,0.5-0.5,0.7C285.8,129.9,286,129.7,286.1,129.5z"
}), React.createElement("path", {
  className: "st2",
  d: "M283.1,131.9c-0.3,0.1-0.6,0.2-0.9,0.3C282.6,132.1,282.8,132,283.1,131.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M285.5,130.2c-0.2,0.2-0.4,0.4-0.6,0.6C285.1,130.7,285.3,130.5,285.5,130.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M284,131.4c-0.3,0.2-0.5,0.3-0.8,0.4C283.5,131.7,283.8,131.6,284,131.4z"
}), React.createElement("path", {
  className: "st2",
  d: "M283.6,121.3c-0.3,0-0.6,0-0.9,0.1l0,0C283,121.3,283.3,121.3,283.6,121.3z"
}), React.createElement("path", {
  className: "st2",
  d: "M280.5,132.3L280.5,132.3c0.6,0.1,1.2,0,1.8-0.1C281.6,132.3,281,132.4,280.5,132.3z"
}), React.createElement("path", {
  className: "st2",
  d: "M286.6,128.6c-0.1,0.3-0.2,0.5-0.4,0.8C286.3,129.1,286.5,128.9,286.6,128.6z"
}), React.createElement("path", {
  className: "st2",
  d: "M284.1,121.4c0.2,0,0.3,0.1,0.5,0.1C284.4,121.5,284.2,121.4,284.1,121.4z"
}), React.createElement("path", {
  className: "st2",
  d: "M283.6,121.3c0.1,0,0.3,0,0.4,0.1C283.9,121.4,283.8,121.3,283.6,121.3z"
}), React.createElement("path", {
  className: "st20",
  d: "M269.9,128.4c1.1,0,2.1-1.3,2.1-3c0-1.6-0.9-3-2.1-3c-1.1,0-2.1,1.3-2.1,3                 C267.8,127.1,268.8,128.4,269.9,128.4z"
}), React.createElement("path", {
  className: "st20",
  d: "M255.1,122.5c-1.1,0-2.1,1.3-2.1,3c0,1.6,0.9,3,2.1,3c1.1,0,2.1-1.3,2.1-3                 C257.2,123.8,256.3,122.5,255.1,122.5z"
}), React.createElement("path", {
  className: "st4",
  d: "M268.5,133.4c0-0.4-0.3-0.7-0.6-0.7h-10.5c-0.4,0-0.7,0.3-0.6,0.7c0.4,2.9,2.9,5.2,5.9,5.2                 S268.1,136.3,268.5,133.4z"
}), React.createElement("path", {
  className: "st17",
  d: "M275,148.4c0.1,0.2,0.3,0.4,0.4,0.6C275.3,148.8,275.1,148.6,275,148.4z"
}), React.createElement("path", {
  className: "st17",
  d: "M275.6,149.2c0.1,0.2,0.2,0.4,0.3,0.6C275.8,149.6,275.7,149.4,275.6,149.2z"
}), React.createElement("path", {
  className: "st17",
  d: "M276,150.1c0.1,0.2,0.2,0.4,0.3,0.6C276.2,150.5,276.1,150.3,276,150.1z"
}), React.createElement("path", {
  className: "st17",
  d: "M274.9,148.3c-0.7-1-1.6-1.8-2.5-2.3C273.4,146.5,274.2,147.3,274.9,148.3z"
}), React.createElement("path", {
  className: "st17",
  d: "M276.4,151c0.1,0.3,0.2,0.6,0.3,0.9C276.6,151.6,276.5,151.3,276.4,151z"
}), React.createElement("polygon", {
  className: "st17",
  points: "278.5,161.6 279.8,161.2 278.5,161.6           "
}), React.createElement("path", {
  className: "st21",
  d: "M283.9,117.1c-0.1,0.6-0.2,1.3-0.4,1.8C283.7,118.4,283.8,117.8,283.9,117.1z"
}), React.createElement("path", {
  className: "st21",
  d: "M284.3,113.9c0,0.1,0,0.2,0,0.3C284.3,114.1,284.3,114,284.3,113.9z"
}), React.createElement("path", {
  className: "st21",
  d: "M280.5,101c0.3,0.4,0.6,0.8,0.8,1.2C281.1,101.8,280.8,101.4,280.5,101z"
}), React.createElement("path", {
  className: "st21",
  d: "M283.5,106.7c0.1,0.4,0.3,0.8,0.4,1.3C283.7,107.5,283.6,107.1,283.5,106.7z"
}), React.createElement("path", {
  className: "st21",
  d: "M278.3,98.5c0.8,0.7,1.5,1.6,2.1,2.4C279.8,100.1,279.1,99.3,278.3,98.5z"
}), React.createElement("path", {
  className: "st21",
  d: "M277.1,97.4c0.4,0.3,0.8,0.7,1.2,1.1C278,98.1,277.6,97.8,277.1,97.4z"
}), React.createElement("path", {
  className: "st21",
  d: "M261.9,94.1C261.9,94.1,261.9,94.1,261.9,94.1C261.9,94.1,261.9,94.1,261.9,94.1z"
}), React.createElement("path", {
  className: "st21",
  d: "M284,116.2c0,0.2,0,0.3-0.1,0.5C284,116.5,284,116.4,284,116.2z"
}), React.createElement("path", {
  className: "st21",
  d: "M284.2,115.1c0,0.1,0,0.3,0,0.4C284.2,115.4,284.2,115.2,284.2,115.1z"
}), React.createElement("path", {
  className: "st21",
  d: "M281.5,102.4c0.3,0.4,0.5,0.8,0.7,1.3C282,103.3,281.7,102.8,281.5,102.4z"
}), React.createElement("path", {
  className: "st21",
  d: "M283.9,108.1c0.1,0.4,0.2,0.9,0.2,1.3C284.1,109,284,108.6,283.9,108.1z"
}), React.createElement("path", {
  className: "st21",
  d: "M282.2,103.8c0.2,0.4,0.4,0.8,0.6,1.3C282.7,104.6,282.5,104.2,282.2,103.8z"
}), React.createElement("path", {
  className: "st21",
  d: "M284.2,110.5c0,0.1,0,0.2,0,0.3C284.3,110.7,284.2,110.6,284.2,110.5z"
}), React.createElement("path", {
  className: "st21",
  d: "M283.5,119.1c-0.2,0.9-0.5,1.7-0.7,2.3C283,120.8,283.3,120,283.5,119.1z"
}), React.createElement("path", {
  className: "st21",
  d: "M284.3,111.6c0,0.1,0,0.2,0,0.2C284.3,111.7,284.3,111.7,284.3,111.6z"
}), React.createElement("path", {
  className: "st21",
  d: "M282.9,105.2c0.2,0.4,0.3,0.8,0.5,1.3C283.2,106,283.1,105.6,282.9,105.2z"
}), React.createElement("path", {
  className: "st21",
  d: "M284.3,112.9c0,0.1,0,0.2,0,0.3C284.3,113,284.3,113,284.3,112.9z"
}), React.createElement("path", {
  className: "st21",
  d: "M244.5,122.4c0.2,0.2,0.4,0.2,0.5,0c1.2-1.1,1.7-10.1,8.8-10.5c4.2-0.2,5.6,1.7,9.4,1.7s6.2-2.7,10.3-1.8                 s5.3,8.3,5.3,8.3s0,0.1,0.1,0.2c-0.8-11.4-8.2-21.8-12.5-26.9c4,0,7.7,1.6,10.6,4c-4.1-3.4-9.4-5.1-15.2-3.3                 c0.1,0,0.4,0.3,1.5,4.6c0,0-3.5-6.5-13.2-4.5c0,0,0,0,2.2,5.4c0,0-5.3-4-11-2.3c0,0,0.7,2.8,1.7,7c0,0-1.7-0.4-2.2,0                 c0,0-0.2,12.4,2.8,17C243.9,121.8,244.2,122.1,244.5,122.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M275.4,149c0,0.1,0.1,0.1,0.1,0.2C275.5,149.2,275.5,149.1,275.4,149z"
}), React.createElement("polygon", {
  className: "st5",
  points: "272.5,146 272.5,146 272.5,146          "
}), React.createElement("polygon", {
  className: "st5",
  points: "281.1,182.5 281.1,182.5 278.5,161.6 278.5,161.6            "
}), React.createElement("path", {
  className: "st5",
  d: "M275.9,149.8c0,0.1,0.1,0.2,0.1,0.3C276,150,275.9,149.9,275.9,149.8z"
}), React.createElement("path", {
  className: "st5",
  d: "M276.3,150.7c0,0.1,0.1,0.2,0.1,0.3C276.4,150.9,276.3,150.8,276.3,150.7z"
}), React.createElement("path", {
  className: "st5",
  d: "M274.9,148.3C275,148.3,275,148.3,274.9,148.3C275,148.3,275,148.3,274.9,148.3z"
}), React.createElement("path", {
  className: "st17",
  d: "M276.7,151.9c-0.1-0.3-0.2-0.6-0.3-0.9c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.2-0.4-0.3-0.6                 c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.2-0.4-0.3-0.6c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.3-0.4-0.4-0.6c0,0,0-0.1-0.1-0.1                 c-0.7-1-1.6-1.8-2.5-2.3c0,0,0,0,0,0c-0.3-0.3-0.6-0.5-1-0.8c-0.2-0.1-0.4-0.3-0.6-0.4c-0.1-0.1-0.2-0.1-0.4-0.2                 c-0.3-0.2-0.6-0.3-0.9-0.4c0,0-0.1,0-0.1,0c-0.5-0.2-1-0.3-1.5-0.4c0,0.1,0,0.2,0,0.3c0,1.4-1.5,2.6-3.3,2.6                 c-1.6,0-3-0.9-3.3-2.1c0-0.1,0-0.1,0-0.2c-3.1,0-8.2,3.6-9,8.1l-1.8,9.7l1.2,0.2l3.8,0.7l-1.1,19.5c3.5,0,7,0.1,10.7,0.1                 c2.9,0,5.8,0,8.7,0l-2.3-18.7l4.6-1.5l2.2-0.7l1.3-0.4L276.7,151.9z"
}), React.createElement("path", {
  className: "st5",
  d: "M268.4,143.8c0.4,0.4,0.8,0.9,1.2,1.4c3.3,4.1,5.4,9.6,6.6,17.2l2.2-0.7l0,0l0,0l1.3-0.4l-3-9.3                 c-0.1-0.3-0.2-0.6-0.3-0.9c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.2-0.4-0.3-0.6c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.2-0.4-0.3-0.6                 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.3-0.4-0.4-0.6c0,0,0-0.1-0.1-0.1c-0.7-1-1.6-1.8-2.5-2.3c0,0,0,0,0,0c0,0,0,0,0,0l0,0                 C271.2,144.8,269.9,144.2,268.4,143.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M278.5,161.6l-2.2,0.7l-4.6,1.5l2.3,18.7c1.3,0,2.5,0,3.7,0c1.1,0,2.3,0,3.4-0.1L278.5,161.6z"
}), React.createElement("path", {
  className: "st5",
  d: "M276.2,162.4c0.9,5.5,1.3,12.2,1.4,20.2c1.1,0,2.3,0,3.4-0.1l-2.6-20.8L276.2,162.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M282.3,132.2C282.3,132.2,282.2,132.2,282.3,132.2C282.2,132.2,282.3,132.2,282.3,132.2z"
}), React.createElement("path", {
  className: "st5",
  d: "M278.3,136.2C278.3,136.2,278.3,136.2,278.3,136.2C278.3,136.2,278.3,136.2,278.3,136.2z"
}), React.createElement("path", {
  className: "st5",
  d: "M277,137.8C277,137.9,276.9,137.9,277,137.8C276.9,137.9,277,137.9,277,137.8z"
}), React.createElement("path", {
  className: "st5",
  d: "M269.1,143.1C269,143.1,269,143.1,269.1,143.1C269,143.1,269,143.1,269.1,143.1z"
}), React.createElement("polygon", {
  className: "st5",
  points: "268,143.4 268,143.4 268,143.4          "
}), React.createElement("path", {
  className: "st5",
  d: "M276.3,138.6C276.2,138.6,276.2,138.7,276.3,138.6C276.2,138.7,276.2,138.6,276.3,138.6z"
}), React.createElement("polygon", {
  className: "st5",
  points: "282.7,121.4 282.7,121.4 282.7,121.4            "
}), React.createElement("path", {
  className: "st5",
  d: "M272,141.8C272,141.8,272,141.8,272,141.8C272,141.8,272,141.8,272,141.8z"
}), React.createElement("path", {
  className: "st5",
  d: "M270.1,142.7c0,0-0.1,0-0.1,0C270,142.7,270.1,142.7,270.1,142.7z"
}), React.createElement("path", {
  className: "st5",
  d: "M271.1,142.3C271,142.3,271,142.3,271.1,142.3C271,142.3,271,142.3,271.1,142.3z"
}), React.createElement("path", {
  className: "st5",
  d: "M277.7,137C277.7,137,277.6,137.1,277.7,137C277.6,137.1,277.7,137,277.7,137z"
}), React.createElement("path", {
  className: "st5",
  d: "M281.4,102.2c0,0.1,0.1,0.1,0.1,0.2C281.4,102.4,281.4,102.3,281.4,102.2z"
}), React.createElement("path", {
  className: "st5",
  d: "M280.4,100.9c0,0,0.1,0.1,0.1,0.1C280.5,101,280.5,101,280.4,100.9z"
}), React.createElement("path", {
  className: "st5",
  d: "M284.3,111.8c0,0.3,0,0.7,0,1C284.3,112.5,284.3,112.2,284.3,111.8z"
}), React.createElement("path", {
  className: "st5",
  d: "M284.3,113.1c0,0.3,0,0.5,0,0.8C284.3,113.7,284.3,113.4,284.3,113.1z"
}), React.createElement("path", {
  className: "st5",
  d: "M278.3,98.5C278.3,98.5,278.3,98.5,278.3,98.5C278.3,98.5,278.3,98.5,278.3,98.5z"
}), React.createElement("path", {
  className: "st5",
  d: "M277.1,97.4C277.1,97.4,277.1,97.4,277.1,97.4C277.1,97.4,277.1,97.4,277.1,97.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M284.3,114.3c0,0.3,0,0.6-0.1,0.8C284.2,114.8,284.2,114.5,284.3,114.3z"
}), React.createElement("path", {
  className: "st5",
  d: "M283.8,107.9c0,0.1,0,0.1,0,0.2C283.9,108.1,283.9,108,283.8,107.9z"
}), React.createElement("path", {
  className: "st5",
  d: "M284.1,109.5c0,0.3,0.1,0.7,0.1,1C284.2,110.1,284.2,109.8,284.1,109.5z"
}), React.createElement("path", {
  className: "st5",
  d: "M283.4,106.4c0,0.1,0.1,0.2,0.1,0.2C283.4,106.6,283.4,106.5,283.4,106.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M284.1,115.5c0,0.2-0.1,0.5-0.1,0.7C284.1,116,284.1,115.7,284.1,115.5z"
}), React.createElement("path", {
  className: "st5",
  d: "M282.8,105c0,0,0,0.1,0.1,0.1C282.9,105.1,282.9,105.1,282.8,105z"
}), React.createElement("path", {
  className: "st5",
  d: "M284.3,110.8c0,0.3,0,0.5,0,0.8C284.3,111.3,284.3,111,284.3,110.8z"
}), React.createElement("path", {
  className: "st5",
  d: "M282.2,103.7C282.2,103.7,282.2,103.7,282.2,103.7C282.2,103.7,282.2,103.7,282.2,103.7z"
}), React.createElement("path", {
  className: "st5",
  d: "M283.6,121.3C283.6,121.3,283.6,121.3,283.6,121.3C283.6,121.3,283.6,121.3,283.6,121.3z"
}), React.createElement("path", {
  className: "st5",
  d: "M283.2,131.9C283.2,131.9,283.2,131.9,283.2,131.9C283.2,131.9,283.2,131.9,283.2,131.9z"
}), React.createElement("path", {
  className: "st5",
  d: "M284,121.4C284,121.4,284.1,121.4,284,121.4C284.1,121.4,284,121.4,284,121.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M285.6,130.1c0,0-0.1,0.1-0.1,0.1C285.5,130.2,285.6,130.2,285.6,130.1z"
}), React.createElement("path", {
  className: "st5",
  d: "M284.9,130.8C284.8,130.9,284.8,130.9,284.9,130.8C284.8,130.9,284.8,130.9,284.9,130.8z"
}), React.createElement("path", {
  className: "st5",
  d: "M286.2,129.4c0,0,0,0.1-0.1,0.1C286.1,129.4,286.2,129.4,286.2,129.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M284,116.7c0,0.2,0,0.3-0.1,0.5C283.9,117,284,116.8,284,116.7z"
}), React.createElement("path", {
  className: "st5",
  d: "M284,131.4C284,131.4,284,131.4,284,131.4C284,131.4,284,131.4,284,131.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M283.5,119c0,0.1,0,0.1,0,0.2C283.5,119.1,283.5,119,283.5,119z"
}), React.createElement("path", {
  className: "st2",
  d: "M284.5,121.5c-0.2-0.1-0.3-0.1-0.5-0.1c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.4-0.1c0,0,0,0,0,0                 c-0.3,0-0.6,0-0.9,0.1c-0.4,1-0.9,1.7-1.3,1.6c-1.3-0.1-2.2-2.1-2.5-2.8c0-0.1-0.1-0.2-0.1-0.2s-1.2-7.4-5.3-8.3                 s-6.5,1.8-10.3,1.8s-5.2-2-9.4-1.7c-7.1,0.4-7.6,9.5-8.8,10.5c-0.2,0.1-0.3,0.2-0.5,0c-0.3-0.3-0.6-0.6-0.9-1                 c-0.2,0-0.5,0-0.8,0.1c-1.5,0.6-2.9,2.5-1.8,5.9c0.6,2,3.2,4,5.1,4.3c2.7,6.6,8.2,11.3,15.2,12.1c0,0.1,0,0.2,0,0.3                 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0.3,1.2,1.6,2.1,3.3,2.1c1.8,0,3.3-1.2,3.3-2.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3                 c0,0,0,0,0,0c0.3-0.1,0.7-0.2,1-0.3c0,0,0.1,0,0.1,0c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0.1,0,0.1,0c0.3-0.1,0.6-0.2,0.9-0.4                 c0,0,0.1,0,0.1,0c0.3-0.1,0.6-0.3,0.9-0.4c0,0,0,0,0,0c1.6-0.8,3-1.9,4.2-3.1c0,0,0,0,0.1-0.1c0.2-0.2,0.4-0.5,0.7-0.7                 c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.4-0.5,0.6-0.7c0,0,0-0.1,0.1-0.1c0.2-0.3,0.4-0.5,0.6-0.8c0,0,0,0,0,0c0.8-1.2,1.6-2.5,2.2-3.9                 c0,0,0,0,0,0c0.6,0.1,1.2,0,1.8-0.1c0,0,0,0,0.1,0c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0,0,0.1,0c0.3-0.1,0.6-0.3,0.8-0.4c0,0,0,0,0,0                 c0.3-0.2,0.5-0.3,0.8-0.5c0,0,0,0,0.1-0.1c0.2-0.2,0.4-0.4,0.6-0.6c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.4-0.4,0.5-0.7                 c0,0,0-0.1,0.1-0.1c0.2-0.2,0.3-0.5,0.4-0.8C288,125.1,286.7,122.4,284.5,121.5z M269.9,122.5c1.1,0,2.1,1.3,2.1,3                 c0,1.6-0.9,3-2.1,3c-1.1,0-2.1-1.3-2.1-3C267.8,123.8,268.8,122.5,269.9,122.5z M255.1,128.4c-1.1,0-2.1-1.3-2.1-3                 c0-1.6,0.9-3,2.1-3c1.1,0,2.1,1.3,2.1,3C257.2,127.1,256.3,128.4,255.1,128.4z M262.6,138.6c-3,0-5.5-2.3-5.9-5.2                 c0-0.4,0.3-0.7,0.6-0.7h10.5c0.4,0,0.7,0.3,0.6,0.7C268.1,136.3,265.6,138.6,262.6,138.6z"
}), React.createElement("path", {
  className: "st5",
  d: "M281.4,123c-1.3-0.1-2.2-2.1-2.5-2.8c0.5,7.7-2.1,15.9-11,23.1l0,0l0,0l0,0c0,0,0,0,0,0                 c0.3-0.1,0.7-0.2,1-0.3c0,0,0.1,0,0.1,0c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0.1,0,0.1,0c0.3-0.1,0.6-0.2,0.9-0.4c0,0,0.1,0,0.1,0                 c0.3-0.1,0.6-0.3,0.9-0.4c0,0,0,0,0,0c1.6-0.8,3-1.9,4.2-3.1c0,0,0,0,0.1-0.1c0.2-0.2,0.4-0.5,0.7-0.7c0,0,0.1-0.1,0.1-0.1                 c0.2-0.2,0.4-0.5,0.6-0.7c0,0,0-0.1,0.1-0.1c0.2-0.3,0.4-0.5,0.6-0.8c0,0,0,0,0,0c0.8-1.2,1.6-2.5,2.2-3.9c0,0,0,0,0,0l0,0l0,0                 c0.6,0.1,1.2,0,1.8-0.1c0,0,0,0,0.1,0c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0,0,0.1,0c0.3-0.1,0.6-0.3,0.8-0.4c0,0,0,0,0,0                 c0.3-0.2,0.5-0.3,0.8-0.5c0,0,0,0,0.1-0.1c0.2-0.2,0.4-0.4,0.6-0.6c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.4-0.4,0.5-0.7                 c0,0,0-0.1,0.1-0.1c0.2-0.2,0.3-0.5,0.4-0.8c1.4-3.5,0.2-6.2-2-7.1c-0.2-0.1-0.3-0.1-0.5-0.1c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.4-0.1                 c0,0,0,0,0,0c-0.3,0-0.6,0-0.9,0.1l0,0l0,0C282.3,122.4,281.8,123.1,281.4,123z"
}), React.createElement("path", {
  className: "st21",
  d: "M278.9,120.3c0.3,0.6,1.2,2.7,2.5,2.8c0.4,0,0.9-0.6,1.3-1.6c0,0,0,0,0,0c0.3-0.6,0.5-1.4,0.7-2.3                 c0-0.1,0-0.1,0-0.2c0.1-0.6,0.3-1.2,0.4-1.8c0-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.3,0.1-0.5c0-0.2,0.1-0.5,0.1-0.7c0-0.1,0-0.3,0-0.4                 c0-0.3,0.1-0.6,0.1-0.8c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5,0-0.8c0-0.1,0-0.2,0-0.3c0-0.3,0-0.7,0-1c0-0.1,0-0.2,0-0.2                 c0-0.3,0-0.6,0-0.8c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.7-0.1-1c-0.1-0.4-0.1-0.9-0.2-1.3c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.2-0.8-0.4-1.3                 c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.4-0.3-0.9-0.5-1.3c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.4-0.9-0.6-1.3c0,0,0,0,0-0.1                 c-0.2-0.4-0.5-0.9-0.7-1.3c0-0.1-0.1-0.1-0.1-0.2c-0.3-0.4-0.5-0.8-0.8-1.2c0,0-0.1-0.1-0.1-0.1c-0.6-0.8-1.3-1.7-2.1-2.4                 c0,0,0,0,0,0c-0.4-0.4-0.8-0.7-1.2-1.1c0,0,0,0,0,0c-3-2.5-6.6-4.1-10.6-4C270.7,98.4,278.2,108.9,278.9,120.3z"
}), React.createElement("path", {
  className: "st5",
  d: "M278.9,120.3c0.3,0.6,1.2,2.7,2.5,2.8c0.4,0,0.9-0.6,1.3-1.6c0,0,0,0,0,0c0.3-0.6,0.5-1.4,0.7-2.3                 c0-0.1,0-0.1,0-0.2c0.1-0.6,0.3-1.2,0.4-1.8c0-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.3,0.1-0.5c0-0.2,0.1-0.5,0.1-0.7c0-0.1,0-0.3,0-0.4                 c0-0.3,0.1-0.6,0.1-0.8c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5,0-0.8c0-0.1,0-0.2,0-0.3c0-0.3,0-0.7,0-1c0-0.1,0-0.2,0-0.2                 c0-0.3,0-0.6,0-0.8c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.7-0.1-1c-0.1-0.4-0.1-0.9-0.2-1.3c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.2-0.8-0.4-1.3                 c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.4-0.3-0.9-0.5-1.3c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.4-0.9-0.6-1.3c0,0,0,0,0-0.1                 c-0.2-0.4-0.5-0.9-0.7-1.3c0-0.1-0.1-0.1-0.1-0.2c-0.3-0.4-0.5-0.8-0.8-1.2c0,0-0.1-0.1-0.1-0.1c-0.6-0.8-1.3-1.7-2.1-2.4                 c0,0,0,0,0,0c-0.4-0.4-0.8-0.7-1.2-1.1c0,0,0,0,0,0c-3-2.5-6.6-4.1-10.6-4C270.7,98.4,278.2,108.9,278.9,120.3z"
}), React.createElement("path", {
  className: "st17",
  d: "M324,149c0.2,0.2,0.3,0.3,0.5,0.5C324.3,149.3,324.1,149.2,324,149z"
}), React.createElement("path", {
  className: "st17",
  d: "M323.4,148.5c0.2,0.1,0.3,0.3,0.5,0.5C323.7,148.8,323.6,148.7,323.4,148.5z"
}), React.createElement("path", {
  className: "st17",
  d: "M326.3,152.4c0.1,0.3,0.2,0.5,0.3,0.8C326.5,152.9,326.4,152.6,326.3,152.4z"
}), React.createElement("path", {
  className: "st17",
  d: "M325.9,151.6c0.1,0.2,0.2,0.4,0.3,0.5C326.1,152,326,151.8,325.9,151.6z"
}), React.createElement("path", {
  className: "st17",
  d: "M322.8,148.1c0.2,0.1,0.4,0.3,0.6,0.4C323.2,148.4,323,148.2,322.8,148.1z"
}), React.createElement("path", {
  className: "st17",
  d: "M324.5,149.6c0.1,0.2,0.3,0.3,0.4,0.5C324.8,149.9,324.6,149.7,324.5,149.6z"
}), React.createElement("path", {
  className: "st17",
  d: "M325,150.2c0.1,0.2,0.2,0.3,0.4,0.5C325.2,150.5,325.1,150.4,325,150.2z"
}), React.createElement("path", {
  className: "st17",
  d: "M325.5,150.9c0.1,0.2,0.2,0.3,0.3,0.5C325.7,151.2,325.6,151,325.5,150.9z"
}), React.createElement("path", {
  className: "st19",
  d: "M330.7,132.4c0,0.1,0,0.2,0,0.2C330.7,132.5,330.7,132.4,330.7,132.4z"
}), React.createElement("path", {
  className: "st19",
  d: "M330.8,131.9C330.8,131.9,330.8,131.9,330.8,131.9C330.8,131.9,330.8,131.9,330.8,131.9z"
}), React.createElement("path", {
  className: "st19",
  d: "M330.7,132.6c0,0.1,0,0.2-0.1,0.3C330.6,132.8,330.6,132.7,330.7,132.6z"
}), React.createElement("path", {
  className: "st19",
  d: "M330.8,132c0,0,0,0.1,0,0.1C330.8,132.1,330.8,132,330.8,132z"
}), React.createElement("path", {
  className: "st19",
  d: "M330.8,132.1c0,0.1,0,0.1,0,0.2C330.7,132.3,330.8,132.2,330.8,132.1z"
}), React.createElement("path", {
  className: "st19",
  d: "M330.6,133c0,0.1-0.1,0.2-0.1,0.4C330.5,133.2,330.6,133.1,330.6,133z"
}), React.createElement("path", {
  className: "st13",
  d: "M306.5,131.4c1.1,0,1.9-1.2,1.9-2.7s-0.9-2.7-1.9-2.7c-1.1,0-1.9,1.2-1.9,2.7S305.4,131.4,306.5,131.4z"
}), React.createElement("path", {
  className: "st13",
  d: "M320.8,125.9c-1.1,0-1.9,1.2-1.9,2.7c0,1.5,0.9,2.7,1.9,2.7c1.1,0,1.9-1.2,1.9-2.7                 C322.7,127.1,321.8,125.9,320.8,125.9z"
}), React.createElement("path", {
  className: "st4",
  d: "M320.8,135.7c0.1-0.4-0.3-0.8-0.7-0.8h-11.8c-0.4,0-0.8,0.4-0.7,0.8c0.4,3.3,3.2,5.9,6.7,5.9                 S320.4,139,320.8,135.7z"
}), React.createElement("path", {
  className: "st5",
  d: "M323.4,148.5C323.4,148.5,323.4,148.5,323.4,148.5C323.4,148.5,323.4,148.5,323.4,148.5z"
}), React.createElement("path", {
  className: "st5",
  d: "M324.4,149.5C324.4,149.5,324.5,149.6,324.4,149.5C324.5,149.6,324.4,149.5,324.4,149.5z"
}), React.createElement("path", {
  className: "st5",
  d: "M323.9,149C323.9,149,323.9,149,323.9,149C323.9,149,323.9,149,323.9,149z"
}), React.createElement("polygon", {
  className: "st5",
  points: "331,179.5 331,179.5 328.9,162.3 329.9,161.8 328.9,162.3            "
}), React.createElement("path", {
  className: "st5",
  d: "M324.9,150.1c0,0,0.1,0.1,0.1,0.1C325,150.2,324.9,150.1,324.9,150.1z"
}), React.createElement("polygon", {
  className: "st5",
  points: "322.8,148.1 322.8,148.1 322.8,148.1 322.8,148.1            "
}), React.createElement("path", {
  className: "st5",
  d: "M326.2,152.2c0,0.1,0.1,0.1,0.1,0.2C326.3,152.3,326.2,152.2,326.2,152.2z"
}), React.createElement("path", {
  className: "st5",
  d: "M325.8,151.4c0,0.1,0.1,0.1,0.1,0.2C325.9,151.5,325.8,151.5,325.8,151.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M325.4,150.7c0,0.1,0.1,0.1,0.1,0.2C325.4,150.8,325.4,150.8,325.4,150.7z"
}), React.createElement("path", {
  className: "st17",
  d: "M326.6,153.2c-0.1-0.3-0.2-0.5-0.3-0.8c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.3-0.5                 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.3-0.3-0.5c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.3-0.4-0.5c0,0-0.1-0.1-0.1-0.1                 c-0.1-0.2-0.3-0.3-0.4-0.5c0,0-0.1-0.1-0.1-0.1c-0.2-0.2-0.3-0.3-0.5-0.5c0,0,0,0,0,0c-0.2-0.2-0.3-0.3-0.5-0.5c0,0,0,0,0,0                 c-0.2-0.1-0.4-0.3-0.6-0.4c0,0,0,0,0,0c0,0,0,0,0,0c-0.3-0.3-0.7-0.6-1.1-0.8c-0.3-0.2-0.5-0.3-0.8-0.5c-0.1,0-0.2-0.1-0.3-0.2                 c-0.4-0.2-0.7-0.3-1.1-0.5c0,0,0,0,0,0c-0.4-0.1-0.9-0.3-1.3-0.3c0,0.1,0,0.2,0,0.3c0,1.4-1.4,2.5-3.1,2.5c-1.6,0-2.9-1-3.1-2.2                 c-0.2,0.1-0.3,0.1-0.5,0.2c-2-0.2-4.5,1.3-6.2,3.9l-1.7,2.7l-0.4,5.4l2.7,1.8l-0.2,2.9l-1.1,18.4c6.9-0.4,13.5-0.9,19.7-1.4                 l-1.9-15.4l3.1-1.2l3.3-1.3l1.1-0.4L326.6,153.2z"
}), React.createElement("path", {
  className: "st5",
  d: "M319.2,147.3c2.9,4.7,4.9,10.4,6.3,16.2l3.3-1.3l1.1-0.4l-3.3-8.7c-0.1-0.3-0.2-0.5-0.3-0.8                 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.3-0.5c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.3-0.3-0.5c0-0.1-0.1-0.1-0.1-0.2                 c-0.1-0.2-0.2-0.3-0.4-0.5c0,0-0.1-0.1-0.1-0.1c-0.1-0.2-0.3-0.3-0.4-0.5c0,0-0.1-0.1-0.1-0.1c-0.2-0.2-0.3-0.3-0.5-0.5                 c0,0,0,0,0,0c-0.2-0.2-0.3-0.3-0.5-0.5c0,0,0,0,0,0c-0.2-0.1-0.4-0.3-0.6-0.4c0,0,0,0,0,0c0,0,0,0,0,0c-1.3-1.2-2.9-1.9-4.5-2.2                 C318.6,146.4,318.9,146.8,319.2,147.3z"
}), React.createElement("path", {
  className: "st19",
  d: "M328.9,162.3l-3.3,1.3l-3.1,1.2l1.9,15.4c1.2-0.1,2.3-0.2,3.5-0.3c1.1-0.1,2.1-0.2,3.2-0.3L328.9,162.3z"
}), React.createElement("path", {
  className: "st5",
  d: "M325.5,163.5c1.3,5.4,2,11.1,2.3,16.3c1.1-0.1,2.1-0.2,3.2-0.3l-2.1-17.3L325.5,163.5z"
}), React.createElement("polygon", {
  className: "st5",
  points: "336,127.3 336,127.3 336,127.3 336,127.3            "
}), React.createElement("path", {
  className: "st5",
  d: "M330.8,132C330.8,132,330.8,132,330.8,132C330.8,132,330.8,132,330.8,132z"
}), React.createElement("path", {
  className: "st5",
  d: "M330.8,132.1C330.8,132.1,330.8,132.1,330.8,132.1C330.8,132.1,330.8,132.1,330.8,132.1z"
}), React.createElement("path", {
  className: "st5",
  d: "M330.7,132.3C330.7,132.3,330.7,132.4,330.7,132.3C330.7,132.4,330.7,132.3,330.7,132.3z"
}), React.createElement("path", {
  className: "st5",
  d: "M330.6,132.9C330.6,132.9,330.6,133,330.6,132.9C330.6,133,330.6,132.9,330.6,132.9z"
}), React.createElement("path", {
  className: "st5",
  d: "M330.7,132.6C330.7,132.6,330.7,132.6,330.7,132.6C330.7,132.6,330.7,132.6,330.7,132.6z"
}), React.createElement("path", {
  className: "st5",
  d: "M330.8,131.8C330.8,131.8,330.8,131.9,330.8,131.8C330.8,131.9,330.8,131.8,330.8,131.8z"
}), React.createElement("path", {
  className: "st5",
  d: "M330.5,133.3C330.5,133.3,330.5,133.3,330.5,133.3C330.5,133.3,330.5,133.3,330.5,133.3z"
}), React.createElement("path", {
  className: "st19",
  d: "M336,127.3C336,127.3,336,127.3,336,127.3c-0.8-2.2-2.4-2.2-3.4-2c-0.2,0.1-0.5,0.2-0.7,0.2                 c-0.1,0.1-0.2,0.1-0.2,0.1s0,0,0-0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.5,0-0.7-0.1c-1.9-0.3-3.3-2-3.3-4c0-0.9,0.3-1.7,0.8-2.4                 c-0.1-0.1-0.1-0.2-0.2-0.2c-0.3,0.1-0.7,0.1-1,0.1c-2.8,0-5-2.2-5.1-4.9c-1.4,1.8-3.8,3-6.6,3c-2.4,0-4.6-0.9-6-2.3                 c0,0.1,0,0.2,0,0.2c0,3.3-2.7,6.1-6.1,6.1c-0.5,0-1-0.1-1.4-0.2c0.5,0.7,0.9,1.5,0.9,2.5c0,2.2-1.8,3.9-3.9,3.9                 c-1,0-1.9-0.4-2.6-1c-1-0.2-2.1,0-2.4,1.5c-0.1,0.4-0.1,0.9-0.1,1.6c0.5,5.4,5,5.1,5,5.1s0.4,1.7,1.7,3.8                 c1.2,1.9,3.2,4.2,6.3,5.8c1.5,0.8,3.4,1.4,5.5,1.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0.2,1.2,1.5,2.2,3.1,2.2                 c1.7,0,3.1-1.1,3.1-2.5c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c8.7-1.6,11.5-9.1,12.3-12.4c0,0,0,0,0,0c0-0.1,0.1-0.2,0.1-0.4                 c0,0,0,0,0,0c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1                 c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0S336.8,133.3,336,127.3z M320.8,125.9c1.1,0,1.9,1.2,1.9,2.7c0,1.5-0.9,2.7-1.9,2.7                 c-1.1,0-1.9-1.2-1.9-2.7C318.9,127.1,319.7,125.9,320.8,125.9z M304.5,128.7c0-1.5,0.9-2.7,1.9-2.7c1.1,0,1.9,1.2,1.9,2.7                 s-0.9,2.7-1.9,2.7C305.4,131.4,304.5,130.2,304.5,128.7z M314.1,141.6c-3.4,0-6.3-2.6-6.7-5.9c-0.1-0.4,0.3-0.8,0.7-0.8h11.8                 c0.4,0,0.8,0.4,0.7,0.8C320.4,139,317.6,141.6,314.1,141.6z"
})), React.createElement("path", {
  className: "st22",
  d: "M118,186.2c0,2.9-12.3,5.3-27.4,5.3s-27.4-2.4-27.4-5.3c0-2.9,3.7-3.6,27.4-3.6S118,183.3,118,186.2z"
}), React.createElement("g", {
  id: "layer1",
  transform: "translate(0,-152.35974)"
}, React.createElement("path", {
  id: "path3047",
  className: "st23",
  d: "M59.2,280.6c1.3,0.2,2.7,0.5,3.9,0.9c0.7,0.3,1.4,0.6,2.1,0.9l-1-4.7                 c-0.6-0.2-1.2-0.3-1.9-0.5c-0.9-0.2-1.8-0.3-2.8-0.3L59.2,280.6L59.2,280.6z"
}), React.createElement("path", {
  id: "path3051",
  className: "st23",
  d: "M126.2,283.6l-2.2,0.6c-0.2-0.7-0.7-1.4-1.3-1.9c-0.6-0.5-1.3-0.8-2-0.9                 c-0.8-0.2-1.6-0.2-2.4-0.1l2-4.4l7.2,3.2L126.2,283.6z"
}), React.createElement("path", {
  id: "path3004",
  className: "st24",
  d: "M121.2,312.8c0.5-0.6,1-1.2,1.4-1.8c0.8-1.4,0.9-3,0.9-4.6c0.3-8.1-1.3-16.2-4.6-23.6                 l-17.8-11c-3-1.5-6.4-2.3-9.8-2.1c-2.7,0.2-5.4,0.9-7.8,2.2l-17.6,12c-4.1,6.8-6.1,14.8-5.8,22.7c0.1,1.5,0.2,3,0.9,4.3                 c0.4,0.7,0.8,1.2,1.3,1.8c3.8,4.6,7.1,9.5,11.4,13.6c4.2,4.1,9.5,7.5,15.4,8.1c3.4,0.3,6.8-0.3,9.9-1.5c3.1-1.2,6-3.1,8.6-5.2                 C112.8,323.5,116.9,318,121.2,312.8L121.2,312.8z"
}), React.createElement("path", {
  id: "path3000",
  className: "st25",
  d: "M97.8,273.7c1.7-2.9,4.1-5.5,6.9-7.4c2-1.3,4.2-2.4,6.6-2.5c2.5-0.2,5.2,0.8,6.9,2.6                 c1.9,1.9,2.8,4.7,3,7.4c0.1,1.1,0.1,2.2-0.1,3.3c-0.2,1.1-0.5,2.1-0.9,3.2l-2.3,6.7c-1.8-3.3-4.4-6.2-7.4-8.4                 C106.8,275.9,102.4,274.2,97.8,273.7z"
}), React.createElement("g", null, React.createElement("path", {
  id: "path3014-7-8_1_",
  className: "st4",
  d: "M84.7,284.9c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.1-0.1,0.3-0.1,0.5c0,0.3,0,0.5,0.1,0.8                     c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0,0.4,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.3,0.3-0.7,0.3-1.1                     s-0.3-0.7-0.6-0.9c-0.2-0.2-0.5-0.2-0.8-0.2c-0.1,0-0.3,0-0.4,0C85,284.8,84.8,284.8,84.7,284.9L84.7,284.9z"
}), React.createElement("path", {
  className: "st4",
  d: "M85.7,287.8c-0.1,0-0.2,0-0.3,0c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.4-0.4-0.5-0.7c-0.1-0.3-0.2-0.6-0.1-1                     c0-0.2,0.1-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.4-0.6h0c0.1-0.1,0.3-0.2,0.5-0.2c0.1,0,0.3-0.1,0.5,0c0.4,0,0.7,0.1,1,0.3                     c0.4,0.3,0.7,0.7,0.8,1.2c0.1,0.5,0,1-0.3,1.4c-0.2,0.2-0.4,0.4-0.7,0.5C86.1,287.7,85.9,287.8,85.7,287.8z M85,285.2                     c-0.1,0-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.2,0,0.4,0.1,0.6c0.1,0.1,0.1,0.3,0.3,0.4c0.1,0.1,0.3,0.2,0.4,0.2                     c0.1,0,0.3,0,0.4,0c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.5,0.2-0.7c0-0.2-0.2-0.5-0.4-0.6c-0.2-0.1-0.4-0.2-0.6-0.2                     c-0.1,0-0.2,0-0.3,0C85.1,285.2,85,285.2,85,285.2z"
})), React.createElement("path", {
  id: "path2996",
  className: "st25",
  d: "M67.1,287.4c-2.3-2.8-3.8-6.4-4.1-10.1c-0.2-2.6,0.1-5.3,1.4-7.6c1.1-1.9,2.7-3.6,4.8-4.4                 c1.8-0.7,3.8-0.9,5.7-0.4c2.1,0.5,3.9,1.8,5.6,3.2c2.1,1.8,4.1,3.9,5.8,6.2c-3.7,0.6-7.2,1.9-10.4,3.9                 C72.2,280.5,69.2,283.7,67.1,287.4L67.1,287.4z"
}), React.createElement("path", {
  id: "path3008",
  className: "st25",
  d: "M92.7,298.8c-3,0-6,0.8-8.4,2.6c-1.2,0.9-2.2,2-2.9,3.3c-0.7,1.3-1.1,2.8-1.2,4.3                 c0,1.5,0.4,3,1,4.3c0.7,1.3,1.7,2.5,2.9,3.5c2.4,1.9,5.4,2.8,8.4,2.9c2.8,0.1,5.7-0.4,8.1-1.8c2.4-1.4,4.3-3.8,4.9-6.5                 c0.3-1.7,0.2-3.5-0.4-5.1c-0.6-1.6-1.6-3-2.9-4.2C99.6,299.8,96.1,298.8,92.7,298.8L92.7,298.8z"
}), React.createElement("g", null, React.createElement("path", {
  id: "path3014-8_1_",
  className: "st4",
  d: "M99.4,284.6c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.3,0.2,0.5,0.3,0.7                     c0.2,0.2,0.3,0.3,0.6,0.4c0.2,0.1,0.5,0.1,0.7,0.1c0.2,0,0.4-0.1,0.6-0.3s0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.5,0-0.8                     c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.4-0.1-0.5-0.1S99.6,284.5,99.4,284.6L99.4,284.6z"
}), React.createElement("path", {
  className: "st4",
  d: "M100.2,287.3c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.3-0.4-0.6-0.4-0.9                     c-0.1-0.4,0-0.7,0.2-1c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.1,0.5-0.1,0.7-0.1c0.2,0,0.4,0.1,0.6,0.2c0.3,0.1,0.5,0.2,0.6,0.3                     c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.3,0.1,0.7,0,1.1c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.3-0.8,0.3                     C100.4,287.3,100.3,287.3,100.2,287.3z M99.9,284.9c-0.1,0-0.2,0-0.3,0h0c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.3-0.1,0.5                     c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.4                     c0.1-0.2,0.1-0.3,0-0.5c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.4-0.2C100.2,284.9,100.1,284.9,99.9,284.9                     C99.9,284.9,99.9,284.9,99.9,284.9z"
})), React.createElement("path", {
  id: "path3014",
  d: "M99.6,284.9c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.1,0.3-0.1,0.5c0,0.2,0.1,0.3,0.1,0.5                 c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.4,0-0.6                 c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2C100.1,284.8,99.8,284.8,99.6,284.9L99.6,284.9z"
}), React.createElement("path", {
  id: "path3014-7",
  d: "M85,285.2c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.3-0.1,0.5c0,0.2,0.1,0.3,0.1,0.5                 c0.2,0.3,0.5,0.5,0.9,0.6c0.4,0,0.7-0.1,1-0.3c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.6-0.3-0.7c-0.1-0.1-0.3-0.2-0.4-0.2                 c-0.2,0-0.3,0-0.5,0C85.3,285,85.1,285.1,85,285.2L85,285.2z"
}), React.createElement("path", {
  id: "path3059",
  d: "M88.8,308.4c-0.3,0-0.5,0.2-0.7,0.4c-0.2,0.2-0.3,0.5-0.4,0.7c-0.1,0.5,0,1.1,0.2,1.6                 c0.1,0.2,0.2,0.4,0.4,0.5c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0,0.3,0,0.5,0c0.2,0,0.3-0.1,0.4-0.1s0.3-0.2,0.4-0.3                 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2,0-0.5-0.1-0.7c-0.1-0.4-0.2-0.7-0.4-1c-0.1-0.1-0.2-0.3-0.4-0.4C89.1,308.4,89,308.4,88.8,308.4                 L88.8,308.4z"
}), React.createElement("path", {
  id: "path3063",
  d: "M97.3,308.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.4,0.6-0.5,0.9c-0.1,0.5,0,0.9,0.2,1.3                 c0.1,0.2,0.3,0.5,0.5,0.6c0.2,0.1,0.4,0.1,0.7,0c0.2,0,0.3-0.1,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.3,0.2-0.7,0.1-1.1                 c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.4-0.5-0.5c-0.1-0.1-0.3-0.1-0.4-0.2C97.6,308.1,97.4,308.1,97.3,308.1L97.3,308.1z"
}), React.createElement("path", {
  id: "path3067",
  className: "st24",
  d: "M85.2,333.8c-0.6,0.5-1.1,1.1-1.6,1.7c-0.4,0.5-0.7,1-1.1,1.6c-2.7,0.9-5.6,1.2-8.4,1                 c-1-0.1-2-0.2-3-0.3c-0.4,0-0.7,0-1.1-0.1c-0.4-0.1-0.7-0.2-1-0.5c-0.2-0.2-0.3-0.5-0.4-0.8s-0.1-0.6-0.1-0.9                 c0-0.9,0.1-1.9,0.3-2.8c0.3-1.3,0.6-2.7,0.7-4c0-1.1-0.1-2.2-0.5-3.3L85.2,333.8L85.2,333.8z"
}), React.createElement("path", {
  id: "path3071",
  className: "st24",
  d: "M95.5,333.9c0.4,0.7,0.9,1.3,1.3,2c0.3,0.5,0.6,1,1.1,1.4c0.8,0.7,1.8,1.1,2.8,1.2                 c1,0.1,2.1,0,3.1,0c2.2-0.1,4.4,0.1,6.4-0.6c0.7-0.2,1.3-0.5,1.8-1.1c0.5-0.6,0.8-1.3,0.8-2.1c0.1-1.4-0.5-2.8-0.6-4.2                 c-0.1-1.6,0.5-3.2,1.6-4.3L95.5,333.9L95.5,333.9z"
}), React.createElement("path", {
  id: "path3083",
  className: "st25",
  d: "M76.4,338.1c0.8,0,1.5-0.2,2.2-0.5c0.5-0.3,1-0.7,1.4-1.2c0.2-0.3,0.3-0.6,0.4-1                 c0-0.4,0-0.7-0.2-1c-0.2-0.3-0.4-0.6-0.7-0.8c-0.9-0.8-1.9-1.4-2.9-1.9c1.5,0.6,3.1,1.2,4.7,1.7c1.3,0.4,2.5,0.7,3.8,1                 c-0.6,0.5-1.2,1-1.7,1.6c-0.5,0.5-0.9,1-1.3,1.6c-1.1,0.4-2.1,0.6-3.3,0.7C78,338.2,77.2,338.2,76.4,338.1z"
}), React.createElement("path", {
  id: "path3075-0",
  className: "st24",
  d: "M77.9,277c-0.7-1.9-1.9-3.6-3.4-4.9c-1.4-1.2-3.1-2.1-4.9-2.3c-1.1-0.1-2.2,0-3.3,0.3                 c-1,0.3-2,0.8-2.9,1.5c0.2-1,0.6-2,1.1-2.9c1.4-2.3,3.8-4,6.5-4.2c1.6-0.2,3.3,0.2,4.9,0.8c1.5,0.6,2.9,1.6,4.2,2.6                 c2.4,1.9,4.5,4.2,6.2,6.7c-2,0.5-4.1,1.1-6.1,1.7C79.5,276.5,78.7,276.8,77.9,277L77.9,277z"
}), React.createElement("path", {
  id: "path3055",
  className: "st26",
  d: "M101.2,278.8c2.9-1.3,6.1-1.8,9.3-2c3.4-0.2,6.9,0,10.2,1c1.3,0.4,2.7,1,3.6,2                 c0.6,0.6,1,1.4,1.2,2.2c0.3,0.8,0.4,1.6,0.4,2.5c0.1,2.6-0.5,5.1-1.3,7.5c-0.5,1.5-1,3.1-2,4.3c-0.9,1.1-2.1,1.8-3.4,2.3                 c-1.8,0.7-3.7,0.9-5.6,0.9c-2.5,0-5.1-0.3-7.4-1.3c-2.5-1-4.6-2.8-6.1-5c-1.6-2.4-2.4-5.2-2.5-8.1c0-0.8,0-1.6,0.1-2.4                 c0.1-0.8,0.4-1.5,0.9-2.2C99.3,279.9,100.2,279.3,101.2,278.8L101.2,278.8z M82.3,277.5c0.8,0.3,1.5,0.6,2.2,1.1                 c0.7,0.4,1.3,1,1.7,1.7c0.6,0.9,0.9,1.9,0.9,3c0.1,1.1-0.1,2.1-0.3,3.1c-0.6,2.6-1.7,5.1-3.5,7.2c-1.5,1.8-3.5,3.2-5.7,3.9                 c-2.8,0.9-5.9,0.7-8.8,0.1c-1.1-0.2-2.3-0.5-3.4-1c-1.1-0.5-2.1-1.1-2.9-1.9c-1.5-1.5-2.1-3.6-2.5-5.7c-0.5-2.5-0.6-5-0.3-7.5                 c0.1-1.3,0.4-2.6,1.2-3.6c0.6-0.9,1.6-1.4,2.5-1.9c2.9-1.2,6.2-0.9,9.3-0.6C75.9,275.8,79.2,276.3,82.3,277.5L82.3,277.5z                  M53.8,275.4v2.2v2.2c0.6,0,1.3,0.3,1.7,0.7c0.4,0.3,0.6,0.7,0.8,1.2c0.2,0.4,0.3,0.9,0.5,1.4c0.7,2.5,1.1,5,1.6,7.5                 c0.3,1.5,0.7,3.1,1.6,4.4c0.9,1.2,2.1,2,3.5,2.7c2.5,1.2,5.3,1.8,8.1,2c3.2,0.2,6.6-0.3,9.4-2c1.7-1,3.2-2.4,4.4-4.1                 c1.2-1.6,2-3.4,2.8-5.2c0.7-1.5,1.3-3,1.9-4.5c0.6-0.4,1.3-0.7,2.1-0.7c0.8,0,1.7,0.3,2.3,0.8c0.6,1.5,1.1,3,1.7,4.5                 c0.7,1.9,1.5,3.7,2.5,5.4c1,1.7,2.3,3.2,3.8,4.4c1.6,1.2,3.5,2.1,5.4,2.5c2.1,0.5,4.3,0.5,6.5,0.3c2-0.2,4-0.5,5.9-1.2                 c1.4-0.5,2.8-1.3,3.7-2.4c1.1-1.4,1.4-3.2,2-4.9c0.5-1.7,1.2-3.3,1.6-5c0.1-0.5,0.2-1.1,0.4-1.6c0.1-0.5,0.4-1.1,0.7-1.5                 c0.4-0.5,0.9-0.9,1.5-1.2c0.5-0.2,1.1-0.3,1.6-0.3v-2.4v-2.2c-2.1-0.7-4.2-1.2-6.4-1.7c-3.6-0.8-7.3-1.5-11-1.5                 c-3.1,0-6.1,0.3-9.2,0.7c-3.1,0.4-6.2,0.9-9.3,1.4c-1,0.2-2.1,0.3-3.1,0.3c-1.4,0-2.9-0.3-4.3-0.6c-2.5-0.5-4.9-1.2-7.4-1.7                 c-2.2-0.5-4.4-1-6.6-1.4c-2-0.3-4.1-0.6-6.1-0.6c-2.4,0-4.7,0.3-7.1,0.7C58.9,274.5,56.3,274.9,53.8,275.4L53.8,275.4z"
}), React.createElement("path", {
  id: "path3075-0-4",
  className: "st24",
  d: "M104.9,275.8c1.3-1.7,2.8-3.3,4.5-4.6c1.5-1.1,3.1-2.1,4.9-2.3c1.1-0.1,2.2,0,3.3,0.3                 c1.2,0.3,2.2,0.9,3.2,1.7c-0.3-1.1-0.7-2.2-1.4-3.2c-1.5-2.2-3.9-3.9-6.6-4.1c-1.7-0.2-3.4,0.2-5,0.8c-1.6,0.7-3,1.6-4.3,2.7                 c-2.3,1.9-4.2,4.1-5.8,6.6c2.1,0.3,4.1,0.9,6.1,1.7C104.2,275.5,104.5,275.7,104.9,275.8L104.9,275.8z"
}), React.createElement("path", {
  id: "path4131",
  className: "st27",
  d: "M91.2,322.4l3.5,0.1l4.5,4.6l-6.9,2.3l-5.9-3.4L91.2,322.4L91.2,322.4z"
}), React.createElement("path", {
  id: "path4139",
  className: "st28",
  d: "M91.5,324.9l-0.8,3.6l3.6,0.1l-1.3-3.8L91.5,324.9z"
}), React.createElement("path", {
  id: "path4595",
  className: "st29",
  d: "M68.9,331.8c0.2-0.6,0.3-1.2,0.4-1.8c0.2-1.1,0.2-2.3,0.1-3.5l16,7.5                 c-0.2,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.2-0.2,0.2L68.9,331.8L68.9,331.8z"
}), React.createElement("path", {
  id: "path3287",
  className: "st29",
  d: "M121.2,313l-29,14.4l-29.9-14.5c0.4,5.1,2.6,10,6.1,13.6c3,3.1,6.9,5.2,11,6.5                 c4.1,1.3,8.4,1.7,12.7,1.7c4.6,0,9.2-0.5,13.6-2c4.3-1.5,8.4-4,11.2-7.7C119.6,321.6,121.2,317.3,121.2,313L121.2,313z"
}), React.createElement("path", {
  id: "path4595-5",
  className: "st29",
  d: "M112.6,332.1c-0.1-0.5-0.2-1.1-0.2-1.7c0-0.6,0-1.1,0.2-1.7l-16.7,5.6                 c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.1,0.1,0.2,0.2,0.3L112.6,332.1z"
}), React.createElement("path", {
  id: "path4084",
  className: "st29",
  d: "M92.4,327.3l0.1,7.2c4.8-0.1,9.5-1,14-2.6c4.1-1.5,8-3.7,10.7-7.1c2.3-3,3.5-6.9,3.3-10.7                 L92.4,327.3L92.4,327.3z"
}), React.createElement("path", {
  id: "path4104",
  className: "st30",
  d: "M95.7,329.5c0,0.6-0.5,1-1,1h0c-0.6,0-1-0.5-1-1v0c0-0.6,0.5-1,1-1                 C95.2,328.5,95.7,329,95.7,329.5z"
}), React.createElement("path", {
  id: "path4135",
  className: "st31",
  d: "M90,324.2l2.4,1.6l2.7-1.7l-2.8-1.6L90,324.2L90,324.2z"
}), React.createElement("path", {
  id: "path4106",
  className: "st4",
  d: "M63.2,313.2l29.2,9.4l-4.3,3.8L63.2,313.2z"
}), React.createElement("path", {
  id: "path4106-0",
  className: "st4",
  d: "M120.1,313.9l-27.8,8.6l4.3,3.8L120.1,313.9L120.1,313.9z"
}), React.createElement("path", {
  id: "path4570",
  className: "st4",
  d: "M84.2,334.6L67.8,331l0.1,2.9L84.2,334.6z"
}), React.createElement("path", {
  id: "path4570-4",
  className: "st4",
  d: "M96.5,335.4l17.3-3.7l-0.1,2.9L96.5,335.4z"
}), React.createElement("g", {
  id: "g3866",
  transform: "matrix(0.98874013,0.14964272,-0.14964272,0.98874013,82.804984,-73.032274)"
}, React.createElement("path", {
  id: "path3070",
  className: "st32",
  d: "M57,338.3c-0.1,0.5-0.1,1.1,0,1.6c0.1,0.6,0.4,1.3,0.7,1.8c1.3,0.5,2.7,0.6,4,0.4                     c1.2-0.2,2.3-0.8,3.5-0.9c0.7-0.1,1.3,0,1.9,0.3c0.6,0.2,1.2,0.7,1.5,1.2c0.3,0.5,0.5,1.1,0.5,1.6c0.7-0.4,1.3-1.2,1.5-2                     c0.2-0.9-0.1-1.9-0.5-2.7c-0.6-1.1-1.7-1.9-2.9-2.2c-2-0.4-4-0.5-6-0.2C59.7,337.4,58.3,337.8,57,338.3L57,338.3z"
}), React.createElement("path", {
  id: "path3854",
  className: "st33",
  d: "M56.9,338.8c1.1-0.5,2.3-0.8,3.5-1c1.8-0.3,3.7-0.2,5.5,0.2c-1.7-0.2-3.4-0.1-5,0.2                     c-1.4,0.2-2.7,0.7-4,1.2c0-0.1,0-0.2,0-0.3C56.9,339,56.9,338.9,56.9,338.8z"
}), React.createElement("path", {
  id: "path3858",
  className: "st33",
  d: "M57,340.1c1.2-0.2,2.3-0.5,3.5-0.8c1.1-0.3,2.3-0.6,3.5-0.6c0.7,0,1.5,0.1,2.2,0.4                     c-0.9-0.1-1.8-0.1-2.7,0.1c-1,0.2-2,0.5-3,0.8c-1.1,0.3-2.3,0.5-3.4,0.6c0-0.1,0-0.2,0-0.2C57.1,340.2,57,340.1,57,340.1                     L57,340.1z"
}), React.createElement("path", {
  id: "path3862",
  className: "st33",
  d: "M57.3,341.1c1,0.2,2,0.2,3,0c0.8-0.2,1.5-0.5,2.2-0.8c0.7-0.3,1.5-0.5,2.3-0.6                     c1,0,1.9,0.3,2.7,0.9c-1.1-0.4-2.2-0.4-3.3-0.2c-1.2,0.3-2.4,0.9-3.6,1.2c-0.9,0.2-1.9,0.3-2.8,0.1c-0.1-0.1-0.1-0.1-0.2-0.2                     C57.4,341.4,57.4,341.2,57.3,341.1L57.3,341.1z"
})), React.createElement("path", {
  id: "path3872",
  className: "st32",
  d: "M88.4,273.5c-0.3,0.2-0.6,0.4-1,0.5c-0.3,0.1-0.6,0.1-1,0.1c-0.3,0-0.7,0.1-0.9,0.2                 c-0.5,0.2-0.9,0.7-1,1.2c-0.5-0.6-0.7-1.4-0.7-2.2c0-0.6,0.2-1.2,0.5-1.7c0.7-0.4,1.5-0.7,2.3-0.9c0.5-0.2,1.1-0.3,1.6-0.5                 c-0.1,0.6-0.1,1.2-0.1,1.8C88.1,272.5,88.2,273,88.4,273.5L88.4,273.5z"
}), React.createElement("path", {
  id: "path3876",
  className: "st33",
  d: "M87.9,270.6c-0.3,0.1-0.6,0.3-0.9,0.4c-0.4,0.1-0.8,0.2-1.2,0.3c-0.4,0.2-0.8,0.4-1.1,0.7                 c0.4-0.2,0.9-0.3,1.4-0.5c0.4-0.1,0.8-0.1,1.1-0.2c0.2-0.1,0.4-0.1,0.6-0.2l0.2-0.3L87.9,270.6L87.9,270.6z"
}), React.createElement("path", {
  id: "path3880",
  className: "st33",
  d: "M88.3,273.3c-0.3,0.2-0.6,0.3-1,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.3,0-0.7,0.1-1,0.2                 c-0.2,0.1-0.4,0.3-0.6,0.5c0.1-0.2,0.2-0.5,0.3-0.6c0.2-0.2,0.4-0.3,0.6-0.4c0.2-0.1,0.5-0.1,0.7-0.1c0.2,0,0.5,0,0.7,0                 c0.4-0.1,0.8-0.2,1.1-0.5l0.1,0.2L88.3,273.3L88.3,273.3z"
}), React.createElement("path", {
  id: "path3884",
  className: "st33",
  d: "M87.9,271.8c-0.2,0.1-0.5,0.1-0.7,0.2c-0.3,0-0.5,0.1-0.8,0.1c-0.8,0.2-1.5,0.7-1.9,1.4                 c0.5-0.5,1.1-0.9,1.8-1c0.4-0.1,0.7-0.1,1.1-0.2c0.2-0.1,0.4-0.1,0.6-0.2L87.9,271.8z"
}), React.createElement("path", {
  className: "st29",
  d: "M120.8,315.1c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l31.1-31.6c0.4-0.4,1-0.4,1.4,0                 c0.4,0.4,0.4,1,0,1.4l-31.1,31.6C121.3,315,121.1,315.1,120.8,315.1z"
})), React.createElement("path", {
  className: "st5",
  d: "M110.3,185.6c0.7-0.2,1.3-0.5,1.8-1.1c0.5-0.6,0.8-1.3,0.8-2.1c0,0,0-0.1,0-0.1l0.8,0l0.1-2.9l-1.3,0.3             c-0.1-0.5-0.2-1.1-0.2-1.6c0-0.4,0-0.7,0.1-1.1c1-0.7,1.9-1.5,2.8-2.3c0.7-0.7,1.4-1.4,2.1-2.2c0.8-1,1.4-2.1,1.9-3.2             c0,0,0,0,0.1,0l2.6-1.3c2.7-1.4,3.7-4.7,2.4-7.4c-0.4-0.8-0.9-1.4-1.6-1.9c0.8-1.4,0.9-3,0.9-4.6c0.1-2.6,0-5.3-0.3-7.9             c0.3-0.3,0.7-0.6,0.9-0.9c1.1-1.4,1.4-3.2,2-4.9c0.5-1.7,1.2-3.3,1.6-5c0.1-0.5,0.2-1.1,0.4-1.6s0.4-1.1,0.7-1.5             c0.4-0.5,0.9-0.9,1.5-1.2c0.5-0.2,1.1-0.3,1.6-0.3v-2.4v-2.2c-2.1-0.7-4.2-1.2-6.4-1.7c-1.4-0.3-2.8-0.6-4.2-0.8             c0-0.7,0-1.4,0-2.1c-0.1-1.2-0.3-2.4-0.7-3.5c-0.2-0.8-0.6-1.5-1-2.2c0.8,4.7,1.1,11.8-2.8,16.9c7.6,16.4,4.3,29.1-9.1,42.8             c1.9,4.3,1.7,8,1.2,10.5C109.3,185.9,109.8,185.8,110.3,185.6z M119.2,131.1l0.8-2.2c0.3,0,0.6,0.1,0.8,0.1c0.7,0.2,1.4,0.5,2,0.9             c0.6,0.5,1,1.1,1.3,1.9l1.8-0.5c0,0.3,0.1,0.5,0.1,0.8c0.1,2.6-0.5,5.1-1.3,7.5c-0.4,1.4-0.9,2.8-1.8,4             C122.1,139.3,120.9,135.1,119.2,131.1z"
}), React.createElement("path", {
  className: "st24",
  d: "M121.8,167.9l-2.6,1.3c-2.7,1.4-6,0.3-7.4-2.4l0,0c-1.4-2.7-0.3-6,2.4-7.4l2.6-1.3c2.7-1.4,6-0.3,7.4,2.4v0             C125.5,163.2,124.5,166.5,121.8,167.9z"
}), React.createElement("ellipse", {
  transform: "matrix(0.774 -0.6332 0.6332 0.774 -75.7642 113.5693)",
  className: "st24",
  cx: 121.2,
  cy: 162.9,
  rx: 2.2,
  ry: 2.6
}));

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st17",
  d: "M282.3,67.8l-4-0.9l-0.4-4.1c0-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.5,0-0.6,0.2l-2.1,3.5l-4-0.9         c-0.2-0.1-0.5,0-0.6,0.2s-0.1,0.5,0.1,0.6l2.7,3.1l-2.1,3.5c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.4,0.2,0.6,0.1l3.8-1.6L278,75         c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.1,0,0.2,0c0.2-0.1,0.3-0.3,0.3-0.5l-0.4-4.1l3.8-1.6c0.2-0.1,0.3-0.3,0.3-0.5         C282.7,68.1,282.5,67.9,282.3,67.8z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st17",
  d: "M39.8,98.6c-0.3,0-0.5-0.1-0.7-0.4c-0.2-0.4,0-0.8,0.3-1c0.4-0.2,0.9-0.4,1.3-0.7c0.4-0.2,0.8,0,1,0.3         c0.2,0.4,0,0.8-0.3,1c-0.4,0.2-0.9,0.4-1.3,0.6C40.1,98.6,40,98.6,39.8,98.6z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "st17",
  d: "M47.1,95.4c-0.3,0-0.6-0.2-0.7-0.5c-0.2-0.4,0-0.8,0.4-1c0.8-0.3,1.6-0.7,2.4-0.9c0.4-0.1,0.8,0.1,1,0.4         c0.1,0.4-0.1,0.8-0.4,1c-0.7,0.3-1.5,0.6-2.3,0.9C47.3,95.4,47.2,95.4,47.1,95.4z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "st17",
  d: "M85.9,110c-0.1,0-0.2,0-0.2,0c-1.4-0.5-2.2-1.5-2.3-2.8c-0.1-1.6,0.7-3.6,2.2-5.6c-1.8-2.6-4.7-5.2-8.1-6.8         c-8.3-4-18.3-2.5-22.3-1.7c-0.4,0.1-0.8-0.2-0.9-0.6c-0.1-0.4,0.2-0.8,0.6-0.9c4.1-0.8,14.5-2.3,23.2,1.8c3.3,1.6,6.3,4.2,8.4,6.9         c2-2.3,4.7-4.7,7.9-6.5c12-6.9,21.5-3.2,21.9-3c0.4,0.2,0.6,0.6,0.4,1c-0.2,0.4-0.6,0.6-1,0.4c-0.1,0-9.2-3.6-20.6,2.9         c-3.3,1.9-5.9,4.2-7.7,6.5c1.2,2,1.9,3.9,1.7,5.5c-0.2,1.6-1.3,2.6-3,2.9C85.9,110,85.9,110,85.9,110z M86.4,102.9         c-1.1,1.6-1.6,3.1-1.5,4.1c0.1,0.7,0.4,1.2,1.1,1.5c1.3-0.3,1.5-1,1.6-1.6C87.7,105.9,87.2,104.5,86.4,102.9z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st4",
  cx: 291.8,
  cy: 90.2,
  r: 5.2
});

var _ref14 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st17",
  cx: 313.2,
  cy: 74.6,
  r: 3.4
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "st17",
  d: "M334.3,90c-3.1,0-5.7-2.6-5.7-5.7s2.6-5.7,5.7-5.7s5.7,2.6,5.7,5.7S337.4,90,334.3,90z M334.3,80.6         c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7c2,0,3.7-1.7,3.7-3.7C338,82.3,336.3,80.6,334.3,80.6z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "st13",
  d: "M331.3,107.9c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0-0.4-0.1-0.8-0.2-1.1c0,0,0,0,0,0c-0.2-0.7-0.5-1.4-0.9-2.1         c0,0,0,0,0,0c-0.2-0.3-0.4-0.6-0.6-0.9c0,0,0,0,0,0c0,0,0,0,0,0c-1.5-1.9-3.9-3.1-6.5-3.1c-1.9,0-3.6,0.6-5,1.7         c-1.5-1.9-3.9-3.2-6.6-3.2c-3.4,0-6.4,2.1-7.7,5.1c-0.5-0.1-1.1-0.2-1.7-0.2c-4.6,0-8.4,3.7-8.4,8.4c0,1.1,0.2,2.2,0.6,3.1         c-2.5,1-4.2,3.5-4.2,6.3c0,2.6,1.5,4.9,3.6,6c0.3-1.5,1.4-1.7,2.4-1.5c0.7,0.6,1.6,1,2.6,1c2.2,0,3.9-1.8,3.9-3.9         c0-0.9-0.3-1.8-0.9-2.5c0.5,0.1,0.9,0.2,1.4,0.2c3.3,0,6.1-2.7,6.1-6.1c0-0.1,0-0.2,0-0.2c1.4,1.4,3.6,2.3,6,2.3         c2.8,0,5.2-1.2,6.6-3c0.1,2.7,2.4,4.9,5.1,4.9c0.4,0,0.7,0,1-0.1c0.1,0.1,0.1,0.2,0.2,0.2c-0.5,0.7-0.8,1.5-0.8,2.4         c0,2,1.4,3.6,3.3,4c0.2,0,0.5,0.1,0.7,0.1c0.2,0,0.4,0,0.6-0.1c0,0,0,0.1,0,0.1s0.1,0,0.2-0.1c0.2,0,0.5-0.1,0.7-0.2         c1-0.2,2.6-0.2,3.4,2c0,0,0,0,0,0c0.2-0.3,0.4-0.5,0.5-0.8c0,0,0-0.1,0-0.1c0.1-0.3,0.3-0.6,0.4-0.9c0,0,0,0,0,0         c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0-0.1,0-0.2c0-0.3,0.1-0.6,0.1-1c0-0.2,0-0.5,0-0.7c0,0,0-0.1,0-0.1c0-0.2-0.1-0.4-0.1-0.6         c0,0,0,0,0,0c-0.1-0.5-0.2-0.9-0.4-1.3c0.5-0.5,0.9-1.1,1.2-1.7c0,0,0,0,0,0c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0-0.1,0-0.1         c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0-0.1,0.1-0.2c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.2,0.1-0.4c0-0.1,0-0.2,0.1-0.4c0-0.2,0-0.5,0-0.8         C338.8,111.3,335.4,107.9,331.3,107.9z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "st5",
  d: "M331.3,107.9c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0-0.4-0.1-0.8-0.2-1.1c0,0,0,0,0,0c-0.2-0.7-0.5-1.4-0.9-2.1         c0,0,0,0,0,0c-0.2-0.3-0.4-0.6-0.6-0.9c0.4,1.3,0.7,2.7,1,4.2c0.2,0.9,0.3,1.8,0.5,2.8c0.3,1.8,0.4,3.6,0.5,5.5c0,0.4,0,0.9,0,1.3         c0,2.6-0.3,5.3-0.8,8c-1.5,6.9-5,13.9-12.3,20.1c8.7-1.6,11.5-9.1,12.3-12.4c0,0,0,0,0,0c0-0.1,0.1-0.2,0.1-0.4c0,0,0,0,0,0         c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0         c0,0,0-0.1,0-0.1c0,0,0,0,0,0s6,1.5,5.2-4.5c0,0,0,0,0,0c0,0,0,0,0,0c0.2-0.3,0.4-0.5,0.5-0.8c0,0,0-0.1,0-0.1         c0.1-0.3,0.3-0.6,0.4-0.9c0,0,0,0,0,0c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0-0.1,0-0.2c0-0.3,0.1-0.6,0.1-1c0-0.2,0-0.5,0-0.7         c0,0,0-0.1,0-0.1c0-0.2-0.1-0.4-0.1-0.6c0,0,0,0,0,0c-0.1-0.5-0.2-0.9-0.4-1.3c0.5-0.5,0.9-1.1,1.2-1.7c0,0,0,0,0,0         c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0-0.1,0-0.1c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0-0.1,0.1-0.2c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.2,0.1-0.4         c0-0.1,0-0.2,0.1-0.4c0-0.2,0-0.5,0-0.8C338.8,111.3,335.4,107.9,331.3,107.9z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_7"
});

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_9"
});

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_10"
});

var _ref21 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_11"
});

var SvgAutomatePocketMoney = function SvgAutomatePocketMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "1 0 400 210",
    style: {
      enableBackground: "new 0 0 400 210"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, React.createElement("g", {
    id: "Layer_8"
  }, React.createElement("g", null, _ref5, React.createElement("g", null, _ref6, React.createElement("clipPath", {
    id: "SVGID_2_"
  }, React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _ref7), _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17), _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAutomatePocketMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/automate_pocket_money.fefc8884.svg";
export { ForwardRef as ReactComponent };